<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" class="el-icon-plus" @click="addFormVisible = true">添加账号</el-button>
    </div>
    <div class="table_container">
      <el-table :data="tableData" highlight-current-row style="width: 100%">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column property="account" label="账号"></el-table-column>
        <el-table-column property="roleName" label="角色"></el-table-column>
        <el-table-column :formatter="formatDate" property="createTime" label="注册时间"></el-table-column>
        <el-table-column width="180" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handlePass(scope.$index, scope.row)">修改密码</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>

      <!--&lt;!&ndash;新增账号&ndash;&gt;-->
      <el-dialog title="添加账号" :visible.sync="addFormVisible" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="name">
            <el-input v-model="addForm.account" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="name">
            <el-input v-model="addForm.password" auto-complete="off" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="name">
            <el-input v-model="addForm.passwords" auto-complete="off" type="password"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" prop="name">
            <el-select v-model="addForm.roleId" placeholder="请选择">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()">提交</el-button>
        </div>
      </el-dialog>

      <!--&lt;!&ndash;编辑账号&ndash;&gt;-->
      <el-dialog title="编辑账号" :visible.sync="dialogFormVisible" v-loading="loading">
        <el-form :model="form" label-width="80px" ref="addForm">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="name">
            <el-input v-model="form.account" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" prop="name">
            <el-select v-model="form.roleId" placeholder="请选择">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="addSubmits()">提交</el-button>
        </div>
      </el-dialog>

      <!--&lt;!&ndash;修改密码&ndash;&gt;-->
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible2" v-loading="loading">
        <el-form :model="addForms" label-width="80px" ref="addForm">
          <el-form-item label="密码" prop="name">
            <el-input v-model="addForms.password" auto-complete="off" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="name">
            <el-input v-model="addForms.passwords" auto-complete="off" type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel2">取消</el-button>
          <el-button type="primary" @click="modpassord()">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import headTop from "../components/headTop";
import {
  getroleList,
  getusersList,
  getusersAdd,
  getusersMod,
  getusersDel
} from "../api/api";
export default {
  inject: ["reload"],
  data() {
    return {
      options: [],
      tableData: [],
      limit: 20,
      total: 0,
      currentPage: 1,
      addFormVisible: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      addForm: {
        account: "",
        name: "",
        password: "",
        passwords: "",
        roleId: ""
      },
      addForms: {
        password: "",
        passwords: ""
      },
      form: {
        account: "",
        name: "",
        id: "",
        roleId: ""
      },
      loading: false
    };
  },
  components: {
    headTop
  },
  methods: {
    formatDate: function(value) {
      var dateee = new Date(value.createTime).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getroleList();
    },
    // 角色名称列表
    getroleList() {
      let params = {
        pageNum: this.currentPage,
        pageSize: this.limit
      };
      getroleList(params)
        .then(res => {
          this.options = res.pageInfo;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 用户列表
    getusersList() {
      let params = {
        pageNum: this.currentPage,
        pageSize: this.limit
      };
      getusersList(params)
        .then(res => {
          this.total = res.total;
          this.tableData = res.pageInfo;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //添加账号
    addSubmit() {
      if (
        this.addForm.name == "" ||
        this.addForm.account == "" ||
        this.addForm.password == "" ||
        this.addForm.passwords == "" ||
        this.addForm.roleId == ""
      ) {
        this.$message({
          type: "error",
          message: "请输入完整信息"
        });
      } else if (this.addForm.passwords != this.addForm.password) {
        this.$message({
          type: "error",
          message: "两次密码不一致"
        });
      } else {
        this.loading = true;
        let params = {
          name: this.addForm.name,
          account: this.addForm.account,
          password: this.addForm.password,
          roleId: this.addForm.roleId,
          operationId: JSON.parse(sessionStorage.getItem("user")).id
        };
        getusersAdd(params)
          .then(res => {
            if (res.state == true) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.loading = false;
              this.addFormVisible = false;
              this.getusersList();
              this.addForm = {};
            } else {
              this.$message({
                type: "error",
                message: "请输入正确信息"
              });
              this.loading = false;
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.account = row.account;
      this.form.roleId = row.roleId;
    },
    //编辑账号
    addSubmits() {
      if (
        this.form.name == "" ||
        this.form.account == "" ||
        this.form.roleId == ""
      ) {
        this.$message({
          type: "error",
          message: "请输入完整信息"
        });
      } else {
        this.loading = true;
        let params = {
          id: this.form.id,
          name: this.form.name,
          account: this.form.account,
          roleId: this.form.roleId,
          operationId: JSON.parse(sessionStorage.getItem("user")).id
        };
        getusersMod(params)
          .then(res => {
            if (res.state == true) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.loading = false;
              this.dialogFormVisible = false;
              this.getusersList();
            } else {
              this.$message({
                type: "error",
                message: "请输入正确信息"
              });
              this.loading = false;
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    //修改密码
    handlePass(index, row) {
      this.dialogFormVisible2 = true;
      this.addForms.id = row.id;
      this.addForms.account = row.account;
      this.addForms.roleId = row.roleId;
      this.addForms.name = row.name;
    },
    modpassord() {
      if (this.addForms.password == "" || this.addForms.passwords == "") {
        this.$message({
          type: "error",
          message: "请输入完整信息"
        });
      } else if (this.addForms.passwords != this.addForms.password) {
        this.$message({
          type: "error",
          message: "两次密码不一致"
        });
      } else {
        this.loading = true;
        let params = {
          password: this.addForms.password,
          id: this.addForms.id,
          operationId: JSON.parse(sessionStorage.getItem("user")).id,
          account: this.addForms.account,
          roleId: this.addForms.roleId,
          name: this.addForms.name
        };
        getusersMod(params)
          .then(res => {
            if (res.state == true) {
              this.$message({
                type: "success",
                message: res.msg
              });
              if (
                JSON.parse(sessionStorage.getItem("user")).id ==
                this.addForms.id
              ) {
                this.$store.commit("del_token");
                sessionStorage.removeItem("user");
                this.$router.push("/");
              } else {
                this.loading = false;
                this.dialogFormVisible2 = false;
              }
            } else {
              this.$message({
                type: "error",
                message: "请输入正确信息"
              });
              this.loading = false;
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    cancel() {
      this.addForm = {};
      this.addFormVisible = false;
    },
    cancel2() {
      this.addForms = {};
      this.dialogFormVisible2 = false;
    },
    handleDelete(index, row) {
      //删除
      this.$confirm("确认删除该记录吗？", "提示", {
        // type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id,
            operationId: JSON.parse(sessionStorage.getItem("user")).id
          };
          getusersDel(params)
            .then(res => {
              if (res.state == true) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.getusersList();
                this.tableData.splice(index, 1);
              } else {
                throw new Error(res.message);
              }
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: res.msg
              });
            });
        })
        .catch(() => {});
    }
  },
  activated() {
    this.getroleList();
    this.getusersList();
  },
};
</script>

<style lang="less">
@import "../style/mixin";
</style>



// WEBPACK FOOTER //
// src/page/account.vue